import { render } from "./Match.vue?vue&type=template&id=d80a214a&scoped=true"
import script from "./Match.vue?vue&type=script&lang=js"
export * from "./Match.vue?vue&type=script&lang=js"

import "./Match.vue?vue&type=style&index=0&id=d80a214a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d80a214a"]])

export default __exports__